import { Field, Int, ObjectType } from '@nestjs/graphql'

@ObjectType()
export class FailedSignupReasonCountDto {
  // A SUBSCRIPTIONS.FAILED_SIGNUP_REASON.
  @Field()
  reason!: string

  @Field(t => Int)
  authors!: number
}

/**
 * One day of failed signups: authors who picked a plan whose first payment never went through. Counted by
 * the day they tried, once per author however many cards they tried that day. [sc-28213]
 */
@ObjectType()
export class FailedSignupStatDto {
  @Field()
  date!: Date

  @Field(t => Int)
  authors!: number

  // The day's authors by why their payment failed, most common first. Each author is counted under their
  // last attempt of the day, so these add up to `authors`.
  @Field(t => [FailedSignupReasonCountDto])
  reasons!: FailedSignupReasonCountDto[]
}
